import { Tooltip } from "@material-ui/core";
import { Fragment } from "react";

export const Icon = ({ src, hoverable, root, onClick, tooltip, style, width, height }) => {
  const Wraper = tooltip ? Tooltip : Fragment;
  const wraperProps = tooltip ? { title: tooltip, placement: "top" } : null;

  return (
    <Wraper {...wraperProps}>
      <img
        className={root}
        src={src}
        height={height}
        width={width}
        alt="icon"
        style={{ cursor: hoverable ? "pointer" : "default", ...style }}
        onClick={onClick}
      />
    </Wraper>
  );
};
